import React, { useEffect, useState } from 'react';
import Selection from '../../../selection';

function CompanyDirector2(props) {
    const [display, setDisplay] = useState(displayPage())

    useEffect(() => {
        setDisplay(displayPage())
    }, [props.page, props.store])

    function displayPage() {
        switch (props.page) {
            case 65:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "What's " + props.store.first_name_2 + "'s shareholding of the company?",
                        content: "This helps lenders understand hwo and what they can offer to lend you.",
                        buttons: {
                            "Less than 20%": {
                                value: "LESS_THAN_20",
                                next: 66
                            },
                            "More than 20%": {
                                value: "MORE_THAN_20",
                                next: 66
                            }
                        }
                    }} id={"shareholding_of_company_2"} setValue={(e) => props.setValue({ ...props.store, shareholding_of_company_2: e })} />
                )

            case 66:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "How many years has " + props.store.first_name_2 + " been in business?",
                        input: {
                            type: "years",
                            placeholder: "0",
                            id: "company_director_years_in_business_2",
                            min: 1,
                            next: 67
                        }
                    }} id={"company_director_years_in_business_2"} setValue={(e) => props.setValue({ ...props.store, company_director_years_in_business_2: e })} />
                )

            case 67:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "What was " + props.store.first_name_2 + "'s salary for 2019–2020?",
                        content: "This is before tax, and excluding any  bonuses, dividends, commission, or overtime, for the 2019-2020 tax year.",
                        input: {
                            type: "number",
                            placeholder: "0",
                            id: "company_director_net_profit_19_20_2",
                            min: 10000,
                            next: 68
                        }
                    }} id={"company_director_net_profit_19_20_2"} setValue={(e) => props.setValue({ ...props.store, company_director_net_profit_19_20_2: e })} />
                )

            case 68:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "What was " + props.store.first_name_2 + "'s salary for 2018–2019?",
                        content: "This is before tax, and excluding any  bonuses, dividends, commission, or overtime, for the 2018-2019 tax year.",
                        input: {
                            type: "number",
                            placeholder: "0",
                            id: "company_director_net_profit_18_19_2",
                            min: 10000,
                            next: 69
                        }
                    }} id={"company_director_net_profit_18_19_2"} setValue={(e) => props.setValue({ ...props.store, company_director_net_profit_18_19_2: e })} />
                )

            case 69:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "What was " + props.store.first_name_2 + "'s operating profit for 2019–2020?",
                        content: "This is any after all business expenses before tax, for the 2019-2020 tax year.",
                        input: {
                            type: "number",
                            placeholder: "0",
                            id: "company_director_operating_profit_19_20_2",
                            min: 10000,
                            next: 70
                        }
                    }} id={"company_director_operating_profit_19_20_2"} setValue={(e) => props.setValue({ ...props.store, company_director_operating_profit_19_20_2: e })} />
                )

            case 70:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        reference: props.store.first_name_2 + "'s details",
                        heading: "What was " + props.store.first_name_2 + "'s operating profit for 2018–2019?",
                        content: "This is any after all business expenses before tax, for the 2018-2019 tax year.",
                        input: {
                            type: "number",
                            placeholder: "0",
                            id: "company_director_operating_profit_18_19_2",
                            min: 10000,
                            next: 72
                        }
                    }} id={"company_director_operating_profit_18_19_2"} setValue={(e) => props.setValue({ ...props.store, company_director_operating_profit_18_19_2: e })} />
                )

        }
    }

    return (
        <div>
            {display}
        </div>
    );
}

export default CompanyDirector2;